import { AbstractControl, ValidatorFn } from '@angular/forms';

export function positiveNumberValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        let valErr = control.errors;

        if (control.value == null || (control.value != null && control.value <= 0)) {
            if (valErr == null) {
                valErr = {};
            }

            if (control.value != null) {
                valErr['positiveNumber'] = {
                    code: 'rfv04'
                };
            }
        } else {
            if (valErr && valErr['positiveNumber']) delete valErr['positiveNumber'];
            if (valErr && Object.keys(valErr).length == 0) valErr = null;
        }

        return valErr;
    };
}
